import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { forwardEmpClothReturn } from '../../../Store/PHPSlice/Cutting/clothIssue';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';

const TableBody = ({
    serialNumber,
    id,
    memoNo,
    empNm,
    clothNm,
    baleNo,
    barcd,
    cmtr,
    sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleOpenWindow = () => {
    window.open(
        '/your-page-url',
        '_blank',
        'width=1000,height=700'
    );
};

    const handleForwardClick = () => {
        // Show confirmation dialog
           console.log("Button Clicked");
    console.log("memoNo =", memoNo);
    console.log("barcode =", barcd);
        if (sts === '1') {
            alert("Employee Cloth Return is  Already Forwarded.....!!!");
        } else {
            const isConfirmed = window.confirm("Are you sure you want to Forward this Cloth?");

            // If user confirms, proceed with deletion
            if (isConfirmed) {
                dispatch(forwardEmpClothReturn({memoNo,barcd}))
                    .then((res) => {
                        // Reload the page to show updated results
                        alert("Cloth Return Forwarded Sucessfully");
                       // console.log(res);
                         window.location.reload();
                    })
                    .catch((error) => {
                        // Handle any errors that occur during the deletion process
                        console.error("Error deleting Item:", error);
                        toast.error("Failed to delete Item");
                    });
            }
        }

    };

    const handleViewClick = () => {
        window.open(`/ClothIssueView/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleClothReturn = () => {
        window.open(`/ClothIssueReturn/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {memoNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {clothNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {baleNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {barcd}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {cmtr}
                </TableCell>


                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <Button  variant="contained" color="primary" onClick={handleClothReturn}>Return</Button>
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell> */}

               <TableCell
    sx={{
        p: 1,
        border: '1px solid #000',
        whiteSpace: 'nowrap'
    }}
    align="center"
>
    {sts === '0' ? (
        <button
            className="btn btn-danger btn-sm"
            onClick={handleForwardClick}
            style={{background:"#ff0000"}}
        >
            Pending
        </button>
    ) : (
        <button
            className="btn btn-success btn-sm"
            onClick={handleOpenWindow}
            style={{background:"green"}}
        >
            Updated
        </button>
    )}
</TableCell>

            </TableRow>
        </>
    );
};

export default React.memo(TableBody);